import { useQuery } from "@tanstack/react-query";
import { newsPageQuery } from "../news.queries";

/**
 * Whether anything has been published yet.
 *
 * The section, its nav item and its address are each offered only once there
 * is something to read, so all three ask this one question and share its
 * answer. One post is enough to answer it, so it asks for one.
 */
export function useHasPublishedNews() {
  const { data, isLoading } = useQuery(newsPageQuery(1, 1));
  return { hasPublishedNews: (data?.total ?? 0) > 0, isLoading };
}

export default useHasPublishedNews;
